export default __webpack_public_path__ + "static/media/landscaping2.fd5b47e0.jpg";